import { useState } from "react";
import type { FaqItem } from "@/mocks/faq";

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="flex flex-col gap-3">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div
            key={item.question}
            className={[
              "rounded-lg border transition-colors overflow-hidden",
              open ? "border-primary-300 bg-primary-50/60" : "border-background-200 bg-background-50",
            ].join(" ")}
          >
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(open ? null : index)}
                aria-expanded={open}
                className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 cursor-pointer"
              >
                <span className="font-heading text-base font-bold text-foreground-950">{item.question}</span>
                <span className="w-7 h-7 flex items-center justify-center shrink-0 rounded-full bg-background-100 text-foreground-700">
                  <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                </span>
              </button>
            </h3>
            {open && (
              <div className="px-5 pb-5 -mt-1">
                <p className="text-sm leading-relaxed text-foreground-700">{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}